<template>
    <div>
         <!--面包屑导航区域-->
        <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>订单管理</el-breadcrumb-item>
            <el-breadcrumb-item>订单列表</el-breadcrumb-item>
        </el-breadcrumb>
        <!--面包屑导航区域-->
        <!--卡片视图区-->
        <el-card>
            <!--搜索与添加区域-->
            <el-row :gutter="20">
                <el-col :span="10">
                    <el-input placeholder="请输入用户手机号" clearable v-model="queryInfo.query" @clear="getOrderList()">
                        <el-button slot="append" icon="el-icon-search" @click="getOrderList()"></el-button>
                    </el-input>
                </el-col>
                <!-- <el-col :span="10"><div style="font-size:12px;color:#ccc;line-height: 40px;">( * 手续费 <span style="color:green;">绿色</span>为已支付，<span style="color:red;">红色</span>为未支付 )</div></el-col> -->
            </el-row>
            <!--搜索与添加区域-->
            <!--用户列表区域-->
            <el-table :data="orderlist" style="width: 100%" stripe size="small" height="430">
                <el-table-column label="ID" type="index"  width="50" fixed></el-table-column>
                <el-table-column label="订单编号" prop="order_no" width="140" fixed>
                    <template slot-scope="scope">
                        <el-tooltip class="item" effect="dark" placement="top">
                            <div slot="content" @click="CopyText(scope.row)">发货地址： {{scope.row.cons_name}},{{scope.row.cons_telephone}},{{scope.row.cons_address}}</div>
                            <span>{{scope.row.order_no}}</span>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column label="用户名" prop="username" width="100"></el-table-column>
                <el-table-column label="商品名称" prop="goods_name" width="180" show-overflow-tooltip></el-table-column>
                <el-table-column label="租期" prop="period" width="100">
                    <template slot-scope="scope" v-if="scope.row.period">
                        <span >{{scope.row.period}} 个月</span>
                    </template>
                </el-table-column>
                <el-table-column label="押金" prop="goods_deposit" width="100">
                    <template slot-scope="scope" v-if="scope.row.goods_deposit">
                        <span style="color: #ff0000;">￥{{scope.row.goods_deposit}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="商品金额" prop="total" width="100">
                    <template slot-scope="scope" v-if="scope.row.goods_price">
                        <span style="color: #ff0000;">￥{{scope.row.goods_price}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="订单金额" prop="amount" width="100">
                    <template slot-scope="scope">
                        <span style="color: #ff0000;">￥{{scope.row.amount}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="租售类型" prop="amount" width="100">
                    <template slot-scope="scope">
                        <span style="color: #ff0000;" v-if="scope.row.use_method == 1">购买</span>
                        <span style="color: #0000ff;" v-if="scope.row.use_method == 2">租赁</span>
                    </template>
                </el-table-column>
                <el-table-column label="发货审核" prop="send_sign" width="100">
                    <template slot-scope="scope">
                        <el-switch active-value="1" inactive-value="0" v-model="scope.row.send_sign" @change="Checked(scope.row.id,scope.row.send_sign)"></el-switch>
                    </template>
                </el-table-column>
                <el-table-column label="订单状态" prop="order_stats" width="90">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.order_stats==0" type="success">待支付</el-tag>
                        <el-tag v-if="scope.row.order_stats==1" type="success">待发货</el-tag>
                        <el-tag v-if="scope.row.order_stats==2" type="warning">已发货</el-tag>
                        <el-tag v-if="scope.row.order_stats==3" type="danger">已归还</el-tag>
                        <el-tag v-if="scope.row.order_stats==4" type="danger">已完成</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="快递单号" prop="tracking_no" width="120">
                    <template slot-scope="scope">
                        <span  @click="CopyNo(scope.row.tracking_no)">{{scope.row.tracking_no}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="归还单号" prop="return_no" width="120">
                    <template slot-scope="scope">
                        <span  @click="CopyNo(scope.row.return_no)">{{scope.row.return_no}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="归还审核" prop="return_sign" width="100">
                    <template slot-scope="scope">
                        <el-switch active-value="1" inactive-value="0" v-model="scope.row.return_sign" @change="ReturnChecked(scope.row.id,scope.row.return_sign)"></el-switch>
                    </template>
                </el-table-column>
                <el-table-column label="支付日期" prop="pay_date" width="140"></el-table-column>
                <el-table-column label="订单日期" prop="order_date" width="140"></el-table-column>
                <!-- <el-table-column label="操作" fixed="right" width="150">
                    <template slot-scope="scope">
                            <el-button v-if="scope.row.order_stats==1" type="danger" size="mini" plain @click="RevokeOrder(scope.row.id)">撤销</el-button>
                            <el-button type="danger" icon="el-icon-delete" size="mini" @click="DelOrder(scope.row.id)"></el-button>
                    </template>
                </el-table-column> -->
            </el-table>
            <!--用户列表区域-->
            <!--分页区域-->
            <br>
            <div align="center">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="queryInfo.pagenum" :page-sizes="[1, 5, 10, 20]"  :page-size="queryInfo.pagesize" 
                layout="total, sizes, prev, pager, next" :total="total">
                </el-pagination>
            </div>
        </el-card>
    </div>
</template>
<script>
export default {
    data(){
        return{
            //获取订单列表的参数对象
            queryInfo: {
                query: '',
                pagenum: 1,
                pagesize: 10
            },
            orderlist: [],
            total: 0,
        }
    },
    created() {
         this.getOrderList()
    },
    methods:{
        async getOrderList() {
           const { data: res} = await this.$http.get('orderlist/',{ params: this.queryInfo })
           if(res.status == 1 && res.data){
                const list = Array.isArray(res.data.list) ? res.data.list : []
                this.total = res.data.totalCount || 0
                this.orderlist = list.map(v => v.fields || {})
                for (let index = 0; index < list.length; index++) {
                    this.orderlist[index].id = list[index].pk
                }
            } else {
                this.total = 0
                this.orderlist = []
            }
            console.log(this.orderlist)
       },
        handleSizeChange(newSize){
          // console.log(newSize)
           this.queryInfo.pagesize = newSize
           this.getOrderList()
       },
       handleCurrentChange(newPage){
          // console.log(newPage)
           this.queryInfo.pagenum = newPage
           this.getOrderList()
       },
       CopyText(row){
            var oInput = document.createElement('input')
            oInput.value = row.cons_address +' '+ row.cons_name +' '+ row.cons_telephone
            document.body.appendChild(oInput)
            oInput.select()
            document.execCommand("Copy")
            oInput.className = 'oInput'
            oInput.style.display = 'none'
            this.$message.success('复制成功！')
        },
        CopyNo(row){
            var oInput = document.createElement('input')
            oInput.value = row
            document.body.appendChild(oInput)
            oInput.select()
            document.execCommand("Copy")
            oInput.className = 'oInput'
            oInput.style.display = 'none'
            this.$message.success('复制成功！')
        },
        async RevokeOrder(id){
            const confirmResult = await this.$confirm('是否要撤销此订单吗?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                        }).catch(err => err)

                        if (confirmResult !== 'confirm'){
                            return this.$message.info('已取消删除！')
                        }
                        const { data: res } = await this.$http.get('orderrevoke/'+ id)
                        // console.log(res)
                        if (res.status === 0) { 
                            this.$message({message: '撤销成功！',type: 'success'})
                        }
                        this.getOrderList()
        },
       async DelOrder(id){
                const confirmResult = await this.$confirm('是否要删除此订单吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                    }).catch(err => err)

                    if (confirmResult !== 'confirm'){
                        return this.$message.info('已取消删除！')
                    }
                    const { data: res } = await this.$http.get('orderdel/'+ id)
                    // console.log(res)
                    if (res.status === 0) { 
                        this.$message({message: '删除成功！',type: 'success'})
                    }
                    this.getOrderList()
       },
       Checked(id,send_sign){
        this.$prompt('请输入快递单号', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputValidator: (value) => {
            return value.trim() ? true : '快递单号不能为空';
          },
          inputErrorMessage: '快递单号不能为空'
        }).then(async({ value }) => {
            const { data: res} = await this.$http.get('checksend/',{ params:{ id:id,sign:send_sign,tracking_no:value }})
            if(res.status === 0){
                this.$message({message: '发货审核通过！',type: 'success'}) 
                this.getOrderList()
            }
            if(res.status === 1){
                this.$message({message: '快递单号已修改！',type: 'success'}) 
                this.getOrderList()
            }
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消输入'
          });  
          this.toggleSendSign(id, false); // 调用方法关闭开关    
        });
        
        //   const { data: res} = await this.$http.get('checksend/',{ params:{ id:id,sign:send_sign }})
        //   if(res.status === 0){
        //      this.$message({message: '发货审核通过！',type: 'success'}) 
        //      this.getOrderList()
        //   }
        //   if(res.status === 1){
        //      this.$message({message: '发货审核取消！',type: 'warning'}) 
        //      this.getOrderList()
        //   }
      },
        toggleSendSign(id, newSign) {
            // 更新本地数据，或者调用后端接口更新数据库中的 send_sign 状态
            const foundOrder = this.orderlist.find(order => order.id === id);
            if (foundOrder) {
                foundOrder.send_sign = newSign ? 1 : 0; // 假设 1 表示审核通过，0 表示未通过
                // 如果需要更新后端状态，可以在这里调用后端接口
                // this.updateSendSignInBackend(id, newSign);
            }
        },
        async ReturnChecked(id,return_sign){
          const { data: res} = await this.$http.get('checkreturn/',{ params:{ id:id,sign:return_sign }})
          if(res.status === 0){
             this.$message({message: '归还审核通过！',type: 'success'}) 
             this.getOrderList()
          }
          if(res.status === 1){
             this.$message({message: '发货审核取消！',type: 'warning'}) 
             this.getOrderList()
          }
        }
    }
}
</script>
<style scoped>
    .cardcss{
        margin: 5px auto ;
        width: 100%;
    }
    .el-breadcrumb{
        width: 100%;
    }
</style>